import React from 'react';
import { SmallUnderline } from "../../styles/components/SmallUnderline";
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';

class ContactUsRawInfoContainer extends React.Component {

  constructor(props) {
    super(props);

    let state = {}

    if(this.props.info && this.props.info.acf){
      state = { ...this.props.info.acf };
    }

    this.state = state;

  }

  render(){
    return (
      <div className={"contact-us-v4-container blue-gradient-background"}>
        <Container>
          <SmallUnderline align="left">
            <h2>CONTACT US</h2>
          </SmallUnderline>
          <Row>
            <Col xs="12" md="6" className="contactLead">Our professional team will assist you in finding the right solution, and discuss further on our tailored lighting solutions.</Col>
            <Col xs="12" md="6" className={"mb-4"}>
              <div className={"contact-info-row"}>
                <div>Tel</div>
                <div>{ this.state.obx_tel }</div>
              </div>
              <div className={"contact-info-row"}>
                <div>Fax</div>
                <div>{ this.state.obx_fax }</div>
              </div>
            </Col>
            <Col xs="12" md="6" className={"mb-4"}>
              <strong>Visiting Address</strong><br/>
              { this.state.obx_address }<br/>
              { this.state.obx_postal_code + " " + this.state.obx_city }<br/>
              { this.state.obx_country }
            </Col>
            <Col xs="12" md="6">
              <div className={"contact-info-row"}>
                <div>VAT ID</div>
                <div>{ this.state.obx_vat_id }</div>
              </div>
              <div className={"contact-info-row"}>
                <div>Comp. no</div>
                <div>{ this.state.obx_comp_number } </div>
              </div>
              <div className={"contact-info-row"}>
                <div>Trade Reg</div>
                <div>{ this.state.obx_trade_reg } </div>
              </div>
              <div className={"contact-info-row"}>
                <div>Domicile</div>
                <div>{ this.state.obx_domicile }</div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export const ContactUsRawInfo = connect(
  state => ({
    info: state.resolve.data.footer
  })
)(ContactUsRawInfoContainer);



// WEBPACK FOOTER //
// ./src/components/contact-us/ContactUsRawInfo.js